(function () {
  if (window.pdpPwwAddToCartInitialized) return;
  window.pdpPwwAddToCartInitialized = true;

  const SELECTOR_BLOCK = "[data-selection-behaviour='add-to-cart']";
  const CHECKER_SELECTOR = ".pdp_pww__checker";

  function isAddToCartMode(block) {
    return block && block.getAttribute("data-selection-behaviour") === "add-to-cart";
  }

  function getSelectedVariantId(pwwItem) {
    if (!pwwItem) return null;

    const activeSwatch = pwwItem.querySelector(".swatch.active a[data-variant-id]");
    if (activeSwatch) return activeSwatch.getAttribute("data-variant-id");

    const select = pwwItem.querySelector("card-variant-customize select");
    if (select && select.selectedIndex > -1) {
      const option = select.options[select.selectedIndex];
      if (option && option.getAttribute("data-variant-id")) {
        return option.getAttribute("data-variant-id");
      }
    }

    // Fallback: first available variant id from the card swatches
    const swatch = pwwItem.querySelector(".swatch a[data-variant-id]");
    if (swatch) return swatch.getAttribute("data-variant-id");

    return null;
  }

  function addToCart(variantId) {
    if (!variantId) return Promise.reject(new Error("No variant id"));

    const cartNotification = document.querySelector("cart-notification");
    if (!cartNotification) return Promise.reject(new Error("cart-notification not found"));

    const config = typeof fetchConfig === "function"
      ? fetchConfig("javascript")
      : { method: "POST", headers: { "Accept": "application/json" } };

    if (config.headers) config.headers["X-Requested-With"] = "XMLHttpRequest";
    if (config.headers && config.headers["Content-Type"]) delete config.headers["Content-Type"];

    const formData = new FormData();
    formData.append("id", variantId);
    formData.append("quantity", "1");

    if (cartNotification.getSectionsToRender) {
      formData.append("sections", cartNotification.getSectionsToRender().map((section) => section.id));
    }
    formData.append("sections_url", window.location.pathname);

    config.body = formData;

    const url = typeof routes !== "undefined" && routes.cart_add_url
      ? routes.cart_add_url
      : "/cart/add.js";

    return fetch(url, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          return Promise.reject(new Error(response.description || response.message));
        }
        if (cartNotification.renderContents) {
          cartNotification.renderContents(response);
        } else if (cartNotification.open) {
          cartNotification.open();
        }
        return response;
      });
  }

  function resetCheckers(block) {
    block.querySelectorAll(CHECKER_SELECTOR).forEach((checker) => {
      checker.classList.remove("checked");
      checker.removeAttribute("aria-checked");
    });
  }

  function markChecked(checker) {
    if (!checker) return;
    checker.classList.add("checked");
    checker.setAttribute("aria-checked", "true");
  }

  function initBlock(block) {
    if (!isAddToCartMode(block)) return;

    resetCheckers(block);

    block.querySelectorAll(CHECKER_SELECTOR).forEach((checker) => {
      checker.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopImmediatePropagation();

        if (checker.classList.contains("checked") || checker.classList.contains("loading")) return;

        const pwwItem = checker.closest(".pdp-pww-item, .pdp_pww-section");
        const variantId = getSelectedVariantId(pwwItem || block);

        checker.classList.add("loading");
        checker.setAttribute("aria-busy", "true");

        addToCart(variantId)
          .then(() => {
            checker.classList.remove("loading");
            checker.removeAttribute("aria-busy");
            markChecked(checker);
          })
          .catch((err) => {
            checker.classList.remove("loading");
            checker.removeAttribute("aria-busy");
            console.error("[pdp-pww-add-to-cart]", err);
          });
      }, true);
    });

    block.addEventListener("change", function (event) {
      const target = event.target;
      if (target.closest && target.closest("select")) {
        const pwwItem = target.closest(".pdp-pww-item, .pdp_pww-section, .thumb-product-card");
        resetCheckers(pwwItem || block);
      }
    }, true);

    block.addEventListener("click", function (event) {
      const swatch = event.target.closest(".swatch a[data-variant-id]");
      if (swatch) {
        const pwwItem = swatch.closest(".pdp-pww-item, .pdp_pww-section, .thumb-product-card");
        resetCheckers(pwwItem || block);
      }
    }, true);
  }

  function init() {
    const blocks = document.querySelectorAll(SELECTOR_BLOCK);
    blocks.forEach(initBlock);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
